/* KISHI KAISEI — disponibilité réelle des articles proposés dans le bundle.

   Le bloc « Complétez votre couteau » vit dans la description du produit :
   c'est du HTML figé, écrit une fois, qui ignore l'inventaire. Un article
   épuisé y reste donc proposé et cochable, et n'échoue qu'une fois au panier.

   Ce fichier lit la disponibilité réelle de chaque ligne au chargement, puis :
   - la reporte sur l'article de remplacement défini dans REPORTS, s'il y en a un ;
   - la neutralise sinon (case bloquée, ligne grisée, mention « Épuisé »).

   Les attributs sont modifiés en place, sans remplacer les noeuds : les
   écouteurs posés par le script du bundle restent valides, et un événement
   « change » suffit à lui faire recalculer total, mensualité et lien d'ajout.

   Pour reporter un article épuisé sur un autre, ajoutez son identifiant de
   variante à REPORTS. Le nom s'écrit à la main, comme dans les fiches : les
   libellés du bundle sont rédigés, ils ne recopient pas le titre Shopify.
*/
(function () {
  'use strict';

  var REPORTS = {
    /* Planche grand format épuisée le 3 septembre 2026, reportée sur la compacte. */
    '64969386361181': {
      handle: 'planche-a-decouper-en-acacia-format-compact',
      nom: 'Planche à découper en acacia · format compact'
    }
  };

  var box = document.getElementById('kkBundle');
  if (!box) return;

  var lignes = [].slice.call(box.querySelectorAll('.kk-b-opt'));
  if (!lignes.length) return;

  var cache = {};
  var RE_HANDLE = new RegExp('/products/([^/?#]+)');

  function produit(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function handleDe(noeud) {
    var lien = noeud.querySelector('.kk-b-name');
    var href = lien ? lien.getAttribute('href') || '' : '';
    var trouve = href.match(RE_HANDLE);
    return trouve ? trouve[1] : null;
  }

  function variante(p, id) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(id)) return p.variants[i];
    }
    return null;
  }

  function euros(centimes) {
    return (centimes / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function neutraliser(input) {
    var ligne = input.parentNode;
    input.checked = false;
    input.disabled = true;
    ligne.classList.add('kk-b-out');
    var prix = ligne.querySelector('.kk-b-price');
    if (prix) prix.textContent = 'Épuisé';
  }

  function reporter(input, report, p) {
    var ligne = input.parentNode;
    var v = p.variants[0];
    input.setAttribute('data-id', String(v.id));
    input.setAttribute('data-price', (v.price / 100).toFixed(2));
    var img = ligne.querySelector('.kk-b-thumb');
    if (img && p.featured_image) {
      img.setAttribute('src', p.featured_image);
      img.setAttribute('alt', report.nom);
    }
    var lien = ligne.querySelector('.kk-b-name');
    if (lien) {
      lien.setAttribute('href', p.url);
      lien.textContent = report.nom;
    }
    var prix = ligne.querySelector('.kk-b-price');
    if (prix) prix.textContent = euros(v.price);
  }

  /* Un pack dont la pièce maîtresse est épuisée n'a plus d'objet : le bouton
     d'ajout mènerait à un panier en erreur. Le bloc entier est alors retiré,
     l'achat du produit restant assuré par le bouton principal de la fiche. */
  function vedetteEpuisee() {
    var m = location.pathname.match(RE_HANDLE);
    var courant = m ? m[1] : null;
    if (!courant) return Promise.resolve(false);
    return produit(courant).then(function (p) {
      var v = variante(p, box.getAttribute('data-knife'));
      return !!v && !v.available;
    });
  }

  function traiter(input) {
    var ligne = input.parentNode;
    var handle = handleDe(ligne);
    if (!handle) return Promise.resolve();

    return produit(handle).then(function (p) {
      var v = variante(p, input.getAttribute('data-id'));
      /* Produit illisible : on préfère ne rien changer plutôt que de retirer
         à tort un article disponible. */
      if (!v || v.available) return;

      var report = REPORTS[input.getAttribute('data-id')];
      if (!report) return neutraliser(input);

      return produit(report.handle).then(function (r) {
        var rv = r && r.variants && r.variants[0];
        var doublon = rv && (String(rv.id) === String(box.getAttribute('data-knife')) ||
          box.querySelector('.kk-b-opt[data-id="' + rv.id + '"]'));
        if (!rv || !rv.available || doublon) return neutraliser(input);
        reporter(input, report, r);
      });
    });
  }

  vedetteEpuisee().then(function (epuisee) {
    if (epuisee) { box.hidden = true; return; }

    return Promise.all(lignes.map(traiter)).then(function () {
      var vivantes = lignes.filter(function (i) { return !i.disabled; });
      if (!vivantes.length) { box.hidden = true; return; }
      /* Fait recalculer total, mensualité et lien d'ajout par le script du bundle. */
      vivantes[0].dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();